module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content program"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'programs'
      }
    }
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("programs")])]), _c('router-link', {
    attrs: {
      "to": {
        name: 'programs-overview',
        params: {
          category: _vm.formatRoute(_vm.category)
        }
      }
    }
  }, [_c('h4', {
    staticClass: "category h-sm"
  }, [_vm._v(_vm._s(_vm.category))])]), _c('h1', {
    staticClass: "h-xl"
  }, [_vm._v(_vm._s(_vm.title))]), _c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.date))]), _c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.startTime) + " - " + _vm._s(_vm.endTime))]), _c('div', {
    staticClass: "location"
  }, [_c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.locationName))]), _c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.location))]), _c('h4', {
    staticClass: "h-sm"
  }, [_vm._v(_vm._s(_vm.locationAdd))])]), _c('h4', {
    staticClass: "share h-sm",
    on: {
      "click": function($event) {
        _vm.share = !_vm.share
      }
    }
  }, [_vm._v("share"), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.share) ? _c('social', {
    attrs: {
      "meta": _vm.shareInfo
    }
  }) : _vm._e()], 1)], 1)], 1), _c('div', {
    staticClass: "col-8_xs-12"
  }, [_c('div', {
    staticClass: "hero"
  }, [(_vm.hero.url) ? _c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.hero.url,
      "alt": _vm.heroCaptions
    }
  }) : _vm._e()]), (_vm.heroCaptions) ? _c('div', {
    staticClass: "captions-hero"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.heroCaptions)
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "copy grid no-margin",
    class: {
      noimage: !_vm.hero.url
    }
  }, [_c('div', {
    staticClass: "col-7_xs-12 wysiwyg",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), (_vm.rsvp.length > 0 && _vm.rsvpAllowed) ? _c('a', {
    staticClass: "col-3_xs-12",
    attrs: {
      "href": _vm.rsvp,
      "target": "_blank"
    }
  }, [_c('h4', {
    staticClass: "rsvp h-sm"
  }, [_vm._v("rsvp for this event")])]) : _vm._e()])]), (_vm.related.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 related"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("related programs")])]) : _vm._e(), (_vm.related.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 related"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.related), function(program) {
    return _c('div', {
      staticClass: "col-5_xs-12 details",
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'programs-page',
          params: {
            category: 'current',
            id: program.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(program.title))]), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(program.content.date))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v(_vm._s(program.content.start_time) + " - " + _vm._s(program.content.end_time))]), _c('div', {
      staticClass: "col-4 related"
    })])], 1)
  }))]) : _vm._e(), (_vm.relatedExhibitions.length > 0) ? _c('div', {
    staticClass: "col-4_xs-12 related"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("related exhibitions")])]) : _vm._e(), (_vm.relatedExhibitions.length > 0) ? _c('div', {
    staticClass: "col-8_xs-12 related"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, _vm._l((_vm.relatedExhibitions), function(exhibition) {
    return _c('div', {
      staticClass: "col-5_xs-12 details",
      attrs: {
        "data-push-right": "off-1"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'exhibition-single',
          params: {
            year: _vm.year(exhibition),
            id: exhibition.uid
          }
        }
      }
    }, [_c('h3', {
      staticClass: "h-m"
    }, [_vm._v(_vm._s(exhibition.content.title))]), _c('h4', {
      staticClass: "h-sm"
    }, [_vm._v(_vm._s(exhibition.content.teaser))]), _c('p', {
      staticClass: "h-sxx"
    }, [_vm._v(_vm._s(_vm.relatedExhibitionDate(exhibition)))]), _c('div', {
      staticClass: "col-4 related"
    })])], 1)
  }))]) : _vm._e()])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-006fceef"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Program.vue
// module id = 219
// module chunks = 1